const divCardEquipment = {
  photo: 'PHOTO'
};

export default divCardEquipment;
